function CityBackground() {
  return (
    <img
      src="/galinv.svg"
      alt=""
      aria-hidden="true"
    />
  );
}

export default CityBackground;
